<template>
  <div class="body-custom" v-loading="loading">
    <div class="card card-custom card-stretch gutter-b">
      <div class="card-header">
        <div class="card-title">
          <span class="card-icon">
            <i class="flaticon2-delivery-package text-primary"></i>
          </span>
          <h3 class="card-label"><b class="title-header">{{ BusinessTitle }}</b></h3>
        </div>
      </div>
      <div class="card-body">
        <el-form ref="ruleForm" class="form-base" v-on:submit.prevent="isSubmit = true">
          <div class="row mb-8">
            <div class="col-md-2">
              <label class="el-form-item__label form-item-start-template">お知らせタイトル</label>
            </div>
            <div class="col-md-3">
              <el-form-item class="mb-0" :class="{'erorr-border':erorr}" prop="oshirase_id">
                <el-select style="width: 100%" class="bg-gray-item" v-model="data.oshirase_id" placeholder="オプション選択">
                  <el-option v-for="value of listNotice" :key="value.oshirase_id" :label="value.oshirase_title"
                    :value="value.oshirase_id">{{ value.oshirase_title }}</el-option>
                </el-select>
              </el-form-item>
              <span class="mt-4" style="color:#F56C6C">{{erorr}}</span>
            </div>
          </div>
          <hr>
          <div class="row mb-8">
            <div class="col-md-2">
              <label class="el-form-item__label form-item-start-template">お知らせタイトル</label>
            </div>
            <div class="col-md-3">
              <el-form-item class="mb-0" prop="oshirase_title">
                <el-input class="bg-gray-item" maxlength="32" placeholder="" v-model="form.oshirase_title"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="row mb-8">
            <div class="col-md-2">
              <label class="el-form-item__label form-item-start-template">お知らせ内容</label>
            </div>
            <div class="col-md-3">
              <el-form-item class="mb-0" prop="oshirase_contents">
                <el-input class="bg-gray-item" maxlength="300" type="textarea" placeholder=""
                  v-model="form.oshirase_contents">
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="row mb-8">
            <div class="col-md-2">
              <label class="el-form-item__label form-item-start-template">ファイル添付</label>
            </div>
            <div class="col-md-6">
              <div class="box-upload border">
                <div class="banner-item">
                  <div class="box-16-9">
                    <input :disabled="getUploadChunksProgress > 0" type="file" :v-model.lazy="files" id="file-name" @change="uploadFile()" style="display:none"/>
                    <label for="file-name" class="file-drag">
                        <div class="start">
                            <div><span :class="`file-upload-btn btn btn-primary ${getUploadChunksProgress > 0?'disabled':''}`">ファイル添付</span>
                                <span class="ml-4">{{ form.file_name ? form.file_name : ""}}</span>
                            </div>
                        </div>
                    </label>
                  </div>
                  <a :href="form.url_download" v-if="form.url_download">{{form.file_name}}</a>
                </div>
                <div v-show="isUploadChunk" class="upload-chunk-progress">
                    <div class="progress-bar progress-bar-striped bg-success"  :style="`width: ${uploadChunkProgress}%`">{{ uploadChunkProgress }}%</div>
                </div>
              </div>
              <p class="el-form-item__error ml-1r" v-if="isShowMsg">{{ errorFileMsg }}</p>
            </div>
          </div>
          <div class="row mb-8">
            <div class="col-md-2">
              <label class="el-form-item__label form-item-start-template">登録日</label>
            </div>
            <div class="col-md-3">
              <el-form-item class="mb-0">
              <p>{{ form.created_at }}</p>
              </el-form-item>
            </div>
          </div>
          <div class="row mb-8">
            <div class="col-md-2">
              <label class="el-form-item__label form-item-start-template">最終更新日</label>
            </div>
            <div class="col-md-3">
              <el-form-item class="mb-0">
              <p>{{ form.updated_at }}</p>
              </el-form-item>
            </div>
          </div>

          <div class="row mb-8">
            <div class="col-md-2">
              <label class="el-form-item__label form-item-start-template">表示フラグ</label>
            </div>
            <div class="col-md-3">
              <el-form-item class="mb-0" prop="oshirase_show_flag">
                <el-radio v-model="form.oshirase_show_flag" :label="1">表示</el-radio>
                <el-radio v-model="form.oshirase_show_flag" :label="0">非表示</el-radio>
              </el-form-item>
            </div>
          </div>

          <div class="row mb-8">
            <div class="col-md-5">
              <el-button class="" type="primary" @click="submitForm()" :disabled="getUploadChunksProgress > 0" >変更</el-button>
            </div>
          </div>
          <input type="hidden" name="_csrf" v-model="form._csrf" />
        </el-form>
      </div>
    </div>
  </div>

</template>

<script>
import { LIST_NOTIFICATION } from "@/core/services/store/notification.module";
import { mapActions, mapGetters } from "vuex";
import apiService from "@/core/services/api.service";
import { SET_TITLE_BUSINESS } from "@/core/services/store/business.module";
import { SUCCESS_MESSAGE } from "@/core/config/constant";
import { getCsrfRandom } from "@/core/services/store/auth.module";
import { UPLOAD_CHUNKS } from "@/core/services/store/upload.module";

export default {
  name: "edit-noti",
  data() {
    return {
      form: {
        oshirase_title: '',
        oshirase_show_flag: '',
        oshirase_contents: '',
        oshirase_id: '',
        file_name: '',
        file_new: false,
        url_download: '',
        created_at: '',
        updated_at: '',
        file_path: '',
        _csrf:''
      },
      files: [],
      data: {},
      erorr: '',
      listNotice: [],
      loading: false,
      isSubmit: false,
      isShowMsg: false,
      errorFileMsg: "",
      isUpload: false
    };
  },
  // async created() {
  //   this.loading = true;
  //   if (this.BusinessTitle == null) {
  //     await this.setTitleBusiness()
  //   }
  //   this.form._csrf = getCsrfRandom()
  //   this.loading = false;
  // },
  async created() {
    this.loading = true;
    await this.listNotification();
    this.listNotice = this.getListNotification
    this.form._csrf = getCsrfRandom()
    this.loading = false;
  },
  computed: {
    ...mapGetters(["getListNotification", 'BusinessTitle', "getUploadChunksProgress"]),
    uploadChunkProgress(){ return parseFloat(this.getUploadChunksProgress)},
    isUploadChunk(){
        const progress = parseFloat(this.getUploadChunksProgress)
        return progress < 100 && progress > 0
    }
  },
  watch: {
    'data.oshirase_id': {
      handler: function () {
        let data = this.listNotice.filter(data => data.oshirase_id == this.data.oshirase_id)[0];
        if (data) {
            this.isShowMsg = false
            this.file=[]
            this.form.file_name=""
            this.form.file_path=""
          this.turnOffErrorMessage('ruleForm')
          this.form.oshirase_title = data.oshirase_title;
          this.form.oshirase_show_flag = data.oshirase_show_flag;
          this.form.oshirase_contents = data.oshirase_contents;
          this.form.oshirase_id = data.oshirase_id;
          this.form.file_name = data.file_name;
          this.form.file_path = data.file_path ? data.file_path : " ";
          this.form.url_download = data.url_download;
          this.form.created_at = data.created_at_format;
          this.form.updated_at = data.updated_at_format;
        }

      },
      deep: true
    }
  },
 
  methods: {
    ...mapActions([LIST_NOTIFICATION, SET_TITLE_BUSINESS, UPLOAD_CHUNKS]),
    async uploadFile() {
      try{
        this.isShowMsg = false
        this.isSubmit = true
        const uploadRes = await this[UPLOAD_CHUNKS]( {file: event.currentTarget.files[0], type_upload : "notification"})
        this.form.file_name = uploadRes.data.file_name;
        this.form.file_new = true;
        this.form.url_download = "";
        this.errorFileMsg = "";
        this.isSubmit = false;
      } catch(e){
        this.errorFileMsg = e.message
        this.isShowMsg = true
        this.isSubmit = false;
      }
    },
    async submitForm() {
      this.isSubmit = true
      this.erorr = ''
      if (this.form.oshirase_id) {
        this.$refs["ruleForm"].clearValidate()
        const formData = new FormData();
        formData.append('oshirase_id', this.form.oshirase_id);
        formData.append('oshirase_title', this.form.oshirase_title);
        formData.append('oshirase_contents', this.form.oshirase_contents);
        formData.append('oshirase_show_flag', this.form.oshirase_show_flag);
        formData.append('file_name', this.form.file_name);
        formData.append('file_new', this.form.file_new);
        formData.append('file_path', '');
        formData.append('_csrf', this.form._csrf);

        this.loading = true
        const headers = { 'Content-Type': 'multipart/form-data' };
        await apiService.post(`notification/add`, formData, headers).then(async data => {
          if (data && data.data && data.data.success) {
            this.notifySuccess(SUCCESS_MESSAGE)
            await this.listNotification();
            this.listNotice = this.getListNotification

            let dataUpdate = null
            for (let i = 0; i < this.listNotice.length; i++) {
              if (this.listNotice[i].oshirase_id == this.form.oshirase_id) {
                dataUpdate = this.listNotice[i]
                break
              }
            }
            if (dataUpdate) {
              this.form.oshirase_title = dataUpdate.oshirase_title
              this.form.oshirase_contents = dataUpdate.oshirase_contents
              this.form.oshirase_show_flag = dataUpdate.oshirase_show_flag
              this.form.created_at = dataUpdate.created_at_format
              this.form.updated_at = dataUpdate.updated_at_format
              this.form.file_name = dataUpdate.file_name
              this.form.url_download = dataUpdate.url_download
            }
          } else {
            if (data.data.code == 422) {
              this.showErrorMessage(data.data.data, 'ruleForm')
            } else {
              this.notifyError('error server')
            }
          }
          this.loading = false
        }).catch(e => {
          this.loading = false
          this.notifyError(e)
        })
      } else {
        this.erorr = '必須項目を入力してください。';
      }

      this.isSubmit = false
    },
    detailNotice() {
      let data = this.listNotice;
      let datas = data.filter(value => {
        return value.oshirase_id == this.form.oshirase_id
      })

      if (datas.length > 0) {
        this.form = datas[0]
      }
    }
  },

}
</script>

<style scoped lang="scss">
.text-erorr{
  color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
}
.erorr-border{
  border: solid 1px rgb(245, 108, 108);
  border-radius: 4px;
}
.box-upload.border {
    position: relative;
}

.upload-chunk-progress {
    position: absolute;
    width: 100%;
    margin-top: 10px;

    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 1rem;
    overflow: hidden;
    line-height: 0;
    font-size: 0.75rem;
    background-color: #EBEDF3;
    border-radius: 0.42rem;
    -webkit-box-shadow: none;
    box-shadow: none;
    
    .progress-bar {
        background-repeat: repeat-x;
    }
}

.file-upload-btn.disabled {
  color: #FFF;
  background-color: #a0cfff;
  border-color: #a0cfff;
}
</style>
